export const columnsGeneralTable = [
    {
        field: 'type',
        header: 'modals.news_execution.approval.stores_detail.table.header.type',
        sortable: true,
    },
    {
        field: 'percentage',
        header: 'modals.news_execution.approval.stores_detail.table.header.percentage',
        sortable: true,
    },
    {
        field: 'completed_stores',
        header: 'modals.news_execution.approval.stores_detail.table.header.completed_stores',
    },
]
